// @flow
import * as React from 'react';
import {
    defineMessages, FormattedMessage, injectIntl, IntlShape,
} from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { getCoordinateSystem, switchCoordinateSystem } from 'esm-web-pro/redux/networks';
import ReactTooltip from 'react-tooltip';
import LabelText from 'esm-web-pro/components/layout/sidePanel/LabelText';
import LocalCoordinateSystem from 'esm-web-pro/assets/images/map/local.svg';
import GlobalCoordinateSystem from 'esm-web-pro/assets/images/map/global.svg';

const messages = defineMessages({
    coordinateSystemControl: {
        id: 'networks-map-coordinates-system-control',
        defaultMessage: 'Coordinates System Control',
    },
});

type Props = {
    intl: IntlShape,
}

const CoordinateSystemControl = (props: Props) => {
    const {
        intl: { formatMessage },
    } = props;

    const dispatch = useDispatch();
    const coordinateSystem = useSelector(getCoordinateSystem);

    const togglecoordinateSystem = (event) => {
        event.preventDefault();

        dispatch(switchCoordinateSystem());
    };

    return (
        <div className="leaflet-bar networks-additional-control coordinates-control">
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a
                title={formatMessage[messages.coordinateSystemControl]}
                onClick={togglecoordinateSystem}
                type="button"
                data-tip
                href="#"
                data-for="coordinates-tooltip"
            >
                { coordinateSystem === process.env.REACT_APP_GIS_TRANSFORM_COORDINATE_SYSTEM
                    ? <img src={LocalCoordinateSystem} alt="coordinate-system-local" />
                    : <img src={GlobalCoordinateSystem} alt="coordinate-system-global" />}
            </a>
            <ReactTooltip
                id="coordinates-tooltip"
                effect="solid"
                place="right"
                className="react-tooltip"
            >
                <LabelText size="small">
                    <FormattedMessage
                        id="current-coordinate-system-message"
                        defaultMessage="Current coordinate system: {value}"
                        values={{ value: coordinateSystem }}
                    />
                </LabelText>
            </ReactTooltip>
        </div>
    );
};


export default injectIntl(CoordinateSystemControl);
